import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { SystemView } from '../../../components/dashboard/admin/system-notices';

SystemNotices.propTypes = {
  viewMain: PropTypes.bool
}

export default function SystemNotices({ viewMain }) {

  return <>
    <Helmet>
      <title>Admin System Notices | Platform Solutions</title>
    </Helmet>

    <SystemView viewMain={viewMain} />
  </>;
}
